import axios from '@/libs/axios'

export function getPatientById(id) {
    return axios.get(`/patients/read/${id}`)
}

export function updatePatientById(id, patientInfo) {
    return axios.patch(`/patients/update/${id}`, patientInfo)
}